module.exports = __webpack_public_path__ + "static/media/caraibes-preview.6aace989.svg";